var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9952 7H13.006M3.4 10.6V20.8M8.2 10.6V20.8M17.8 10.6V20.8M22.6 10.6V20.8M1 8.884C1 7.4476 1.5784 6.568 2.776 5.9008L7.708 3.1564C10.2916 1.72 11.584 1 13 1C14.416 1 15.7084 1.72 18.292 3.1564L23.224 5.9008C24.4204 6.568 25 7.4476 25 8.884C25 9.2728 25 9.4684 24.958 9.628C24.7348 10.468 23.9728 10.6012 23.2372 10.6012H2.7628C2.0272 10.6012 1.2664 10.4692 1.042 9.628C1 9.4672 1 9.2728 1 8.884ZM21.4 20.8H4.6C3.64522 20.8 2.72955 21.1793 2.05442 21.8544C1.37928 22.5295 1 23.4452 1 24.4C1 24.5591 1.06321 24.7117 1.17574 24.8243C1.28826 24.9368 1.44087 25 1.6 25H24.4C24.5591 25 24.7117 24.9368 24.8243 24.8243C24.9368 24.7117 25 24.5591 25 24.4C25 23.4452 24.6207 22.5295 23.9456 21.8544C23.2705 21.1793 22.3548 20.8 21.4 20.8Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.f060eb5ec9b66689943384a12a1e3fd9.svg";
export { ForwardRef as ReactComponent };